export enum FavoriteTabNames {
  FOODS = 'FOODS',
  RECIPES = 'RECIPES',
  USER_EATABLES = 'USER_EATABLES',
  MOTIONS = 'MOTIONS'
}

export const itemTypeNames: Record<FavoriteTabNames, string> = {
  [FavoriteTabNames.FOODS]: 'Nahrungsmittel',
  [FavoriteTabNames.RECIPES]: 'Rezepte',
  [FavoriteTabNames.USER_EATABLES]: 'eigenen Nahrungsmittel oder Rezepte',
  [FavoriteTabNames.MOTIONS]: 'Aktivitäten'
}
